import { jsx as _jsx } from "react/jsx-runtime";
import { Button as UIButton } from "@sundae/ui-toolkit";
import cn from "classnames";
import { forwardRef, useMemo } from "react";
import { useAppContext } from "../../stores/index.js";
const Button = forwardRef(({ className, ...props }, ref) => {
    const { state: { clientSettings: { externalRoutes, clientTranslations, brand }, }, } = useAppContext();
    const customClasses = useMemo(() => {
        if (props.variant === "primary" || props.variant === "gradient") {
            return cn(className, brand.buttons.primary.className, "leading-none");
        }
        else {
            return cn(className, brand.buttons.secondary.className, "leading-none");
        }
    }, [brand.buttons, props.variant, className]);
    return _jsx(UIButton, { ...props, ref: ref, className: customClasses });
});
export default Button;
//# sourceMappingURL=Button.js.map